import { useEffect, useState, useSyncExternalStore } from 'react';
import type { LivePresence, PresenceToast } from '../../collaboration/rt/livePresence';
import { rich } from '../../i18n/rich';

/** The app's `MultiplayerJoinToast`: 3 s on screen, then 200 ms in which it fades and the ones below take its place. */
const SHOWN_MS = 3000, HIDE_MS = 200;

const words = (toast: PresenceToast) => rich(toast.joined ? '#WebParticipantJoins' : '#WebParticipantLeaves', <bdi className="participant-toast-name">{toast.name}</bdi>);

function ParticipantToast({ toast, presence }: { toast: PresenceToast; presence: LivePresence }) {
  const [leaving, setLeaving] = useState(false);
  useEffect(() => {
    const timers = [setTimeout(() => setLeaving(true), SHOWN_MS), setTimeout(() => presence.dismiss(toast.id), SHOWN_MS + HIDE_MS)];
    return () => timers.forEach(clearTimeout);
  }, [presence, toast.id]);
  return <div className={'participant-toast-slot' + (leaving ? ' is-leaving' : '')}>
    <div className="participant-toast-clip"><div className="participant-toast-space">
      <div className="participant-toast"><span>{words(toast)}</span></div>
    </div></div>
  </div>;
}

/**
 * Who joins and leaves the app's live room, under the header's notices, newest at the bottom. `hidden` (a presentation)
 * keeps their clocks running unseen; the newest is said again in a live region outside the stack, which comes and goes.
 */
export function ParticipantToasts({ presence, hidden }: { presence: LivePresence; hidden: boolean }) {
  const toasts = useSyncExternalStore(presence.subscribe, presence.toasts), newest = toasts.at(-1);
  return <>
    <span className="participant-toasts-said" role="status" aria-live="polite">{newest && !hidden && words(newest)}</span>
    {toasts.length > 0 && <div className="participant-toasts" hidden={hidden} aria-hidden="true">
      {toasts.map(toast => <ParticipantToast key={toast.id} toast={toast} presence={presence} />)}
    </div>}
  </>;
}
